import Endpoints from '../endpoints';
import { axiosInstance } from '../instance';

export const getList = async (params) => {
  try {
    const res = await axiosInstance.get(Endpoints.PRICE_SOURCES.GET_LIST, {
      params,
    });
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось получить список источников' };
  }
};

export const patch = async (brand_id, body) => {
  try {
    const res = await axiosInstance.patch(
      Endpoints.PRICE_SOURCES.PATCH + `/${brand_id}`,
      body
    );
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось обновить источник' };
  }
};

export const create = async (body) => {
  try {
    const res = await axiosInstance.post(Endpoints.PRICE_SOURCES.CREATE, body);
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось создать источник' };
  }
};

export const remapApply = async (body) => {
  try {
    const res = await axiosInstance.post(Endpoints.REMAP.APPLY, body || {});
    // 202 = started, 409 = already running
    return res.data;
  } catch (e) {
    if (e.response?.status === 409) return e.response.data;
    console.log(e);
    return { error: 'Не удалось запустить переназначение' };
  }
};

export const remapStatus = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.REMAP.STATUS);
    return res.data;
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось получить статус' };
  }
};

export const getUseRrp = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.PRICE_SOURCES.USE_RRP);
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось получить список брендов с РРЦ' };
  }
};

export const addUseRrpBrand = async (brand) => {
  try {
    const res = await axiosInstance.post(Endpoints.PRICE_SOURCES.USE_RRP_BRANDS, {
      brand,
    });
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: e.response?.data?.error || 'Не удалось добавить бренд в РРЦ' };
  }
};

export const removeUseRrpBrand = async (brand) => {
  try {
    const res = await axiosInstance.delete(
      Endpoints.PRICE_SOURCES.USE_RRP_BRANDS + `/${encodeURIComponent(brand)}`
    );
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось удалить бренд из РРЦ' };
  }
};

const priceSources = {
  getList,
  patch,
  create,
  remapApply,
  remapStatus,
  getUseRrp,
  addUseRrpBrand,
  removeUseRrpBrand,
};
export default priceSources;
